
import React from 'react';
import 'swiper/swiper.min.css';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { useQuery } from 'react-query';
import Loading from '../Loading/Loading';

// import required modules
// import { Pagination, Navigation } from "swiper";
SwiperCore.use([Navigation, Pagination, Autoplay]);



const Banner = () => {

  const { data, isLoading } = useQuery("slider", () => fetch(`${process.env.REACT_APP_SECRET_API}/slider`, {
    method: "GET",
    headers: {
      'content-type': "application/json",
      "X-Requested-With": "XMLHttpRequest",
      'authorization': `Bearer ${localStorage.getItem('token')}`
    }
  }).then((res) => res.json()
  )
  )

  if (isLoading) {
    return <Loading></Loading>
  }

  const slider = data.data

  return (
    <Swiper
      navigation
      // pagination={{ clickable: true }}
      autoplay={{ delay: 4000 }}
      pagination={{
        type: "progressbar",
      }}
      modules={[Pagination, Navigation]}
      grabCursor={true}
      className="mySwiper"
    >
      {slider?.map(item => (
        <SwiperSlide className='p-0' style={{ padding: "0px" }}>
          <img src={item?.slide.original_url} alt="Slide 1" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
export default Banner;
